// Wait for the committed result, including finite CSS/Web Animations, then leave
// a short readable result window. This never changes server settlement.
export const waitForPresentation = async (selector, instant = false) => {
  if (instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  await new Promise((resolve) => {
    const fallback = setTimeout(resolve, 80);
    requestAnimationFrame(() => requestAnimationFrame(() => { clearTimeout(fallback); resolve(); }));
  });
  const animations = document.querySelector(selector)?.getAnimations?.({ subtree: true }) || [];
  await Promise.all(animations.filter((animation) => animation.effect?.getComputedTiming().iterations !== Infinity)
    .map((animation) => animation.finished.catch(() => {})));
  await new Promise((resolve) => setTimeout(resolve, 150));
};